module.exports = __webpack_public_path__ + "static/media/logo.a77b5164.png";